import { Link, StyleSheet, Text, View } from '@react-pdf/renderer';
import type { CdaDocument } from '../../parsers/types';
import { styles as globalStyles } from './pdf-cda-renderer';
import { styles as headingStyles } from './pdf-heading-renderer';

interface PdfTableOfContentsRendererProps {
  data: CdaDocument;
}

const styles = StyleSheet.create({
  container: {
    fontFamily: 'Inter',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 10,
    gap: 10,
  },
  listItem: {
    fontFamily: 'Inter',
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  bullet: {
    fontWeight: 400,
    marginLeft: 5,
    marginRight: 5,
  },
});

export const PdfTableOfContentsRenderer = ({ data }: PdfTableOfContentsRendererProps) => {
  return (
    <View style={styles.container}>
      <Text style={headingStyles.h2}>Table of Contents</Text>
      {data.content?.sections.map((section, index) => (
        <View key={`toc-${section.id}-${index}`} style={styles.listItem}>
          <Text style={[globalStyles.text, styles.bullet]}>{index + 1}.</Text>
          <View style={{ flex: 1 }}>
            <Link
              style={[globalStyles.text, globalStyles.link]}
              src={`#section-${section.id}-${section.index}`}
            >
              {section.title}
            </Link>
          </View>
        </View>
      ))}
    </View>
  );
};
